/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export function getRoundRobinIndex(index, total) {
    return (index + total) % total;
}
//# sourceMappingURL=array.js.map
